import React, { useEffect, useState } from 'react';

import { string } from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useHistory, useLocation } from 'react-router-dom';

import InvoicesList from './InvoiceList';
import PartnersList from './PartnersList';
import Invoice from './Invoice';
import { BackToTop, Tabs } from '../../../../common';
import {
  financeAPIRoutes,
  PATH_FINANCE_DASHBOARD,
} from '../../../../constants';

export default function InvoiceContainer({ selectedNavigation }) {
  const history = useHistory();
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const currentDate = new Date();
  const [timeFrame, setTimeFrame] = useState({
    startDate: `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`,
    endDate: `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`,
  });
  const [timeFrameType, setTimeFrameType] = useState('allTime');
  const [isTimeFrameChange, setIsTimeFrameChange] = useState(false);

  const { search } = useLocation();
  const query = React.useMemo(() => new URLSearchParams(search), [search]);
  const isPathCorrect = ['invoices', 'partners'].includes(query.get('tab'));
  const [viewComponent, setViewComponent] = useState(
    isPathCorrect ? query.get('tab') : 'invoices',
  );

  useEffect(() => {
    if (!isPathCorrect) {
      history.push(
        `${PATH_FINANCE_DASHBOARD}${financeAPIRoutes[selectedNavigation]}?tab=invoices`,
      );
    }
  }, [history, isPathCorrect, selectedNavigation]);

  const onTabClick = (selectedTab) => {
    setViewComponent(selectedTab);
    history.push(
      `${PATH_FINANCE_DASHBOARD}${financeAPIRoutes[selectedNavigation]}?tab=${selectedTab}`,
    );
  };

  return (
    <>
      <Invoice
        setTimeFrame={setTimeFrame}
        setTimeFrameType={setTimeFrameType}
        setIsTimeFrameChange={setIsTimeFrameChange}
        selectedNavigation={selectedNavigation}
      />
      {!isDesktop && (
        <Tabs>
          <ul className="tabs">
            <li
              className={viewComponent === 'invoices' ? 'active' : ''}
              onClick={() => onTabClick('invoices')}
              role="presentation"
            >
              Invoices
            </li>

            <li
              className={viewComponent === 'partners' ? 'active' : ''}
              onClick={() => onTabClick('partners')}
              role="presentation"
            >
              Partners
            </li>
          </ul>
        </Tabs>
      )}

      <div className="row mt-3">
        {viewComponent === 'invoices' ? (
          <InvoicesList
            viewComponent={viewComponent}
            onTabClick={onTabClick}
            timeFrame={timeFrame}
            timeFrameType={timeFrameType}
            isTimeFrameChange={isTimeFrameChange}
            setIsTimeFrameChange={setIsTimeFrameChange}
            isDesktop={isDesktop}
            isTablet={isTablet}
            selectedNavigation={selectedNavigation}
          />
        ) : (
          <PartnersList
            viewComponent={viewComponent}
            onTabClick={onTabClick}
            timeFrame={timeFrame}
            timeFrameType={timeFrameType}
            isTimeFrameChange={isTimeFrameChange}
            setIsTimeFrameChange={setIsTimeFrameChange}
            isDesktop={isDesktop}
            isTablet={isTablet}
            selectedNavigation={selectedNavigation}
          />
        )}
        <div className="col-12 mt-5">
          <BackToTop />
        </div>
      </div>
    </>
  );
}

InvoiceContainer.defaultProps = {
  selectedNavigation: 'rev share',
};
InvoiceContainer.propTypes = { selectedNavigation: string };
